// Tournament.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./tournament.css";

function Tournament() {
  const navigate = useNavigate();

  const [tournaments, setTournaments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchTournaments = async () => {
      const token = localStorage.getItem("token");
      console.log("Token:", token);
      
      try {
        const headers = {};
        
        // Only add Authorization header if token exists
        if (token) {
          headers.Authorization = `Bearer ${token}`;
        }
        
        const response = await fetch(
          "https://api.asterickx.com/api/Tournament",
          { headers }
        );
        
        // If unauthorized and we had a token, clear it but continue to show tournaments
        if (response.status === 401 && token) {
          console.log("Token expired, clearing from storage");
          localStorage.removeItem("token");
          // Don't redirect here - let user view tournaments
        }
        
        if (!response.ok && response.status !== 401) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        
        // If 401, try to fetch without token (public access)
        let data;
        if (response.status === 401) {
          const publicResponse = await fetch(
            "https://api.asterickx.com/api/Tournament"
          );
          if (publicResponse.ok) {
            data = await publicResponse.json();
          } else {
            throw new Error("Unable to fetch tournaments");
          }
        } else {
          data = await response.json();
        }
        
        console.log("Tournament data:", data);

        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        
        // Filter tournaments by end date AND status
        const filteredTournaments = data.filter((tournament) => {
          const endDate = new Date(tournament.endDate);
          const isNotExpired = endDate >= currentDate;
          const isActive = tournament.status && tournament.status.toLowerCase() === 'active';
          
          return isNotExpired && isActive;
        });
        
        console.log("Filtered tournaments:", filteredTournaments);

        const sortedTournaments = filteredTournaments.sort(
          (a, b) => new Date(a.startDate) - new Date(b.startDate)
        );

        setTournaments(sortedTournaments);
      } catch (err) {
        console.error("Error fetching tournaments:", err);
        setError("Failed to load tournaments. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchTournaments();
  }, [navigate]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleRegister = (tournament) => {
    console.log("Registering for tournament:", tournament);
    
    const token = localStorage.getItem("token");
    const registrationUrl = `/registration?tournamentId=${tournament.id}`;
    
    if (token) {
      // If logged in, go directly to registration page with tournament data
      navigate(registrationUrl, { 
        state: { 
          selectedTournament: tournament,
          tournamentCode: tournament.tournamentCode || tournament.code || `TOURN-${tournament.id}`
        } 
      });
    } else {
      // If not logged in, go to login with redirect param
      navigate(`/login?redirect=${encodeURIComponent(registrationUrl)}`);
    }
  };

  return (
    <div className="container mt-5" style={{ marginBottom: "10rem" }}>
      <h2 className="text-center mt-4">Tournament Details</h2>
      
      {error && <p className="text-danger text-center">{error}</p>}
      <div className="table-responsive">
        <table className="table table-bordered table-hover">
          <thead className="table-dark">
            <tr>
              <th>Tournament Name</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Venue</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="5" className="text-center">
                  Loading...
                </td>
              </tr>
            ) : tournaments.length > 0 ? (
              tournaments.map((tournament) => (
                <tr key={tournament.id}>
                  <td>{tournament.tournamentName}</td>
                  <td>{formatDate(tournament.startDate)}</td>
                  <td>{formatDate(tournament.endDate)}</td>
                  <td>{tournament.venue}</td>
                  <td>
                    <button
                      className="btn btn-primary"
                      onClick={() => handleRegister(tournament)}
                      disabled={loading}
                    >
                      Register
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center">
                  No tournaments available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Tournament;